import qs from 'qs'

import { Retailer } from 'types'
import { makeRequest } from 'utils/requests'

type DuplicateOrdersType = {
  orderIds: String[]
  retailer: Pick<Retailer, 'id' | 'displayName'>
}

export const duplicateOrders = ({
  orderIds,
  retailer,
}: DuplicateOrdersType): Promise<any> => {
  const url = '/orders/duplicate_orders'
  const data = {
    orderIds,
    orderForAccountId: retailer.id,
    orderForLabel: retailer.displayName,
  }

  // TODO(ch15462) rebuild endpoint
  return makeRequest({
    headers: {
      Accept: 'application/json, text/javascript, */*; q=0.01',
      'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
    },
    method: 'post',
    url,
    data: qs.stringify(data),
  })
}
